import { createSelector } from "reselect";
import { RootState } from '../../../reducers';
import { selectClientsState } from "src/features/clients/store/selectors";

export const selectTermDeposit = createSelector(
  (state: RootState) => state,
  (state) => state.expiringTermDeposit
);

export const selectExpiringTermDepositList = createSelector(
  selectTermDeposit,
  (termDepositState) => termDepositState.list.termDepositList?.results ?? []
);

export const selectListState = createSelector(selectClientsState, (clientsState) => clientsState.list);
export const selectParameters = createSelector(selectListState, (listState) => listState.parameters);
export const selectTermDepositParameters = createSelector(selectTermDeposit, (termDepositState) => termDepositState.list.parameters);
